module.exports = __webpack_public_path__ + "static/media/logotype.c8958b80.png";